__turbopack_context__.v({
  "answer": "VXiBpW_answer",
  "badge": "VXiBpW_badge",
  "intro": "VXiBpW_intro",
  "introText": "VXiBpW_introText",
  "list": "VXiBpW_list",
  "root": "VXiBpW_root",
});
